
import IconButton from '@mui/material/IconButton';

import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useState } from 'react';

// displays the table number of table requesting assistance
// button to check to close the request
export default function WaitAssistanceCard({ tableNumber, close }) {

    const [icon, setIcon] = useState(<CheckCircleOutlineIcon />);

    function handleClose() {
        setIcon(<CheckCircleIcon style={{ color: 'green' }}></CheckCircleIcon>)
        close(tableNumber);
    }

    return (
        <Box sx={{ borderRadius: '25px', backgroundColor: '#eeeeee', justifyContent:'space-between',
                    display: 'flex', flexDirection: 'row', width: 1, p: 2}}>
            <Typography variant="h4" sx={{display: 'flex', flexDirection: 'column'}}>
                Table {tableNumber}
                {/*<Typography variant="caption" sx={{ml: 0.5}}>1:30m</Typography> Removing because time of request not implemented*/}
            </Typography>
            <IconButton aria-label="delete" onClick={handleClose}>
                {icon}
            </IconButton>

        </Box>
    )

}